/**
 * Module-level tracking to prevent duplicate canvas loading across component instances.
 * Tracks which flowId was loaded, not just whether loading happened.
 */
let loadedFlowId: string | null = null;

export const getLoadedFlowId = () => loadedFlowId;

export const setLoadedFlowId = (flowId: string) => {
  loadedFlowId = flowId;
};

/**
 * Reset the canvas load state. Call this when navigating away from Create screen
 * or when the app state is reset to allow fresh canvas loading on next preset.
 */
export const resetCanvasLoadState = () => {
  loadedFlowId = null;
};
